module.exports = __webpack_public_path__ + "static/media/fleurs.24f11837.png";